export default "<button class=\"btn btn-link\" type=\"button\" (click)=\"viewPart()\" title=\"View\">\n    View\n</button>\n"